import React from 'react'

import { useTranslation } from 'react-i18next'
import { useToasts } from 'react-toast-notifications'

import { setLocalStorage } from '@sweetspot/shared/util/local-storage'

import { getApiPlatformBaseUrl } from '@sweetspot/shared/util/functions'
import { STORAGE_KEYS } from '@sweetspot/shared/util/constants'
import { Button } from '@sweetspot/scramble-ds/atoms'
import { Input, InputBase, InputContainer, InputLabelContainer } from '@sweetspot/scramble-ds'
import { cn } from '@sweetspot/scramble-ds/utils'

const EnvSelector = (props) => {
  const { t } = useTranslation()
  const { addToast } = useToasts()
  const [platformENV, setPlatformENV] = React.useState('')

  const onChangeENV = (target, value = '') => {
    value = value.trim()
    if (target === 'platform') setPlatformENV(value)
  }

  const copyToInput = (target) => {
    if (target === 'platform' && !platformENV) {
      setPlatformENV(getApiPlatformBaseUrl())
    }
  }

  const onSave = () => {
    if (!platformENV) {
      addToast(t('envSelector.error_Empty'), { appearance: 'error' })
      return
    }

    setLocalStorage(STORAGE_KEYS.API_PLATFORM_URL_KEY, platformENV)
    addToast(t('envSelector.message_Success'), { appearance: 'success' })
    setPlatformENV('')
  }
  return (
    <div className={cn('w-full py-6')}>
      <p className={'text-xl font-bold'}>Current environment</p>
      <p className={'cursor-pointer'} onClick={() => copyToInput('platform')}>
        {getApiPlatformBaseUrl()}
      </p>

      <InputBase className="mt-3 w-full">
        <InputLabelContainer className="text-sm text-neutral-900">
          Environment url
        </InputLabelContainer>
        <InputContainer>
          <Input
            type="text"
            value={platformENV}
            onChange={(e) => onChangeENV('platform', e.target.value)}
          />
        </InputContainer>
      </InputBase>
      <Button className="mt-6" onClick={onSave}>
        {t('words.save')}
      </Button>
    </div>
  )
}

EnvSelector.propTypes = {}

export default EnvSelector
